import { createTheme } from "@mui/material/styles";

const LightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#c9dfed",
      dark: "#0c2639",
    },
    secondary: {
      main: "#ebdeb8",
    },
    background: {
      default: "#f5f5f5",
    },
    text: {
      primary: "#0c2639",
      secondary: "#ebdeb8",
    },
  },
  props: {
    "MuiInputLabel-root": {
      color: "#0c2639",
    },
  },
});

export default LightTheme;
